/* HB THEME MODE — assets/hb-mode.js (preview, 20 Oct 2026)
   Sun/moon button in the header. The mode itself is set before first paint by a
   tiny inline script in layout/theme.liquid (device preference, then saved choice),
   so there is no flash. Stores one word ("light"/"dark") in localStorage; nothing else. */
(function () {
  'use strict';
  if (window.__hbMode) return; window.__hbMode = 1;
  var root = document.documentElement;
  var SVG = '<svg class="hb-mode__moon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M20.5 14.6A8.5 8.5 0 0 1 9.4 3.5a.6.6 0 0 0-.8-.7A9.5 9.5 0 1 0 21.2 15.4a.6.6 0 0 0-.7-.8z"/></svg>' +
            '<svg class="hb-mode__sun" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="4.5" fill="currentColor"/><g stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 1.8v2.6M12 19.6v2.6M1.8 12h2.6M19.6 12h2.6M4.8 4.8l1.8 1.8M17.4 17.4l1.8 1.8M4.8 19.2l1.8-1.8M17.4 6.6l1.8-1.8"/></g></svg>';
  function cur() { return root.getAttribute('data-theme') === 'light' ? 'light' : 'dark'; }
  function sync(btn) {
    var light = cur() === 'light';
    btn.setAttribute('aria-pressed', light ? 'true' : 'false');
    btn.setAttribute('aria-label', 'Light mode');
    btn.title = light ? 'Switch to dark mode' : 'Switch to light mode';
  }
  function set(mode) {
    root.classList.add('hb-mode-anim');
    root.setAttribute('data-theme', mode);
    try { localStorage.setItem('hb-theme', mode); } catch (e) {}
    var m = document.querySelector('meta[name="theme-color"]');
    if (m) m.setAttribute('content', mode === 'light' ? '#FFFFFF' : '#16101A');
    document.querySelectorAll('.hb-mode').forEach(sync);
  }
  function make() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hb-mode'; b.innerHTML = SVG;
    b.addEventListener('click', function () { set(cur() === 'light' ? 'dark' : 'light'); });
    sync(b);
    return b;
  }
  /* every page gets the button: the shop header, the Reliquary's own header,
     and, if a page has neither, a small floating button bottom-left */
  function mount() {
    var spots = document.querySelectorAll('.header__icons, .rqx__portico-act');
    var placed = false;
    Array.prototype.forEach.call(spots, function (el) {
      if (el.offsetParent === null && !el.closest('.rqx')) return;   /* hidden header (e.g. under the Reliquary) */
      if (!el.querySelector('.hb-mode')) el.insertBefore(make(), el.firstChild);
      placed = true;
    });
    if (!placed && !document.querySelector('.hb-mode')) {
      var f = make(); f.classList.add('hb-mode--float'); document.body.appendChild(f);
    }
  }
  /* follow the device setting live, unless the shopper has picked one */
  try {
    var mq = matchMedia('(prefers-color-scheme: light)');
    var h = function (e) { var s = null; try { s = localStorage.getItem('hb-theme'); } catch (x) {}
      if (!s) { root.setAttribute('data-theme', e.matches ? 'light' : 'dark'); document.querySelectorAll('.hb-mode').forEach(sync); } };
    mq.addEventListener ? mq.addEventListener('change', h) : mq.addListener(h);
  } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
